import { render, staticRenderFns } from "./SeatMapWrapper.vue?vue&type=template&id=6487157c&scoped=true&"
import script from "./SeatMapWrapper.vue?vue&type=script&lang=js&"
export * from "./SeatMapWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SeatMapWrapper.vue?vue&type=style&index=0&id=6487157c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6487157c",
  null
  
)

export default component.exports